import React from 'react';
import { Rectangle, Cushion, Typography } from '@pitchero/react-ui';
import Icon from '../../icon';
import { Trans } from '../../../lib/i18n';

const NoProductsBanner = () => (
  <Rectangle fill="mercury">
    <Cushion
      all="large"
      style={{ textAlign: 'center' }}
      component="div"
      responsive={[{ minWidth: 'tab', props: { all: 'xlarge' } }]}
    >
      <Rectangle
        fill="primary"
        radius="circle"
        component="div"
        style={{
          display: 'inline-block',
          height: '45px',
          width: '45px',
          zIndex: 999,
        }}
      >
        <Cushion all={12}>
          <Icon name="trolley" color="white" size={22} />
        </Cushion>
      </Rectangle>
      <Cushion top="small" bottom="xsmall">
        <Typography preset="staticSubtitle--large" component="div">
          <Trans i18nKey="shop:no_products_banner_header">No products available</Trans>
        </Typography>
      </Cushion>
      <Typography preset="body--small" color="dustygrey">
        <Trans i18nKey="shop:no_products_banner_body">
          There aren’t any products available at the moment
        </Trans>
      </Typography>
    </Cushion>
  </Rectangle>
);

export default NoProductsBanner;
